import { render, staticRenderFns } from "./FeaturedServiceLayout.vue?vue&type=template&id=47376252"
import script from "./FeaturedServiceLayout.vue?vue&type=script&lang=js"
export * from "./FeaturedServiceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports